import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const Contact = () => {
  return (
    <Wrapper>
      <TopContainer>
        <div>
          <h2>Receive a reply in minutes</h2>
          <p>By chat</p>
          <p>Estimated wait: &lt;1 min</p>
          <p>1-800-555-1234</p>
          <p>Estimated wait: 2 mins</p>
        </div>
        <div>
          <h2>Not urgent? Send us an email</h2>
          <p>support@finnick.com</p>
          <p>Usually replies within 1 hour</p>
        </div>
      </TopContainer>
      <BottomContainer>
        <ImageContainer>
          <StaticImage
            src="../images/online-team-meeting.png"
            alt="A team having a meeting online."
            quality="100"
            placeholder="tracedSVG"
          />
        </ImageContainer>
        <Text>
          <h1>A global team of financial specialists at your service.</h1>
          <p>
            Imperdiet sed euismod nisi porta lorem mollis aliquam. Nullam eget
            felis eget nunc lobortis mattis aliquam faucibus purus. Non blandit
            massa enim nec. Tellus rutrum tellus pellentesque eu tincidunt
            tortor aliquam nulla facilisi.
          </p>
          <p>
            Faucibus scelerisque eleifend donec pretium. Cursus risus at
            ultrices mi tempus imperdiet. Diam quis enim lobortis scelerisque
            fermentum dui faucibus.
          </p>
          <p>
            Risus pretium quam vulputate dignissim suspendisse in est ante. Sed
            enim ut sem viverra aliquet eget sit. Magna sit amet purus gravida
            quis blandit. Auctor neque vitae tempus quam pellentesque.
          </p>
        </Text>
      </BottomContainer>
    </Wrapper>
  )
}

export default Contact

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: 900px) {
    margin-top: 50px;
  }
`

const TopContainer = styled.div`
  width: 90%;
  max-width: 1100px;

  p {
    line-height: 1.5rem;
  }

  p :nth-child(2),
  p :nth-child(4),
  p :nth-child(6) {
    cursor: pointer;
    width: fit-content;
  }

  p :nth-child(3),
  p :nth-child(5),
  p :nth-child(7) {
    color: #8a8a8a;
  }

  p :nth-child(5) {
    margin-bottom: 10px;
  }

  h2 {
    margin-bottom: 10px;
  }

  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: space-between;
  }
`

const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95%;
  max-width: 1300px;

  @media screen and (min-width: 900px) {
    flex-direction: row-reverse;
  }
`

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 80%;
`

const Text = styled.div`
  max-width: 800px;

  p {
    margin-top: 10px;
    line-height: 1.5rem;
  }

  @media screen and (min-width: 900px) {
    margin-right: 25px;
  }
`
